import React, { useState, useEffect} from 'react';
import { getProcesses ,getSampleBotList} from "../../Redux/actions/processes";
import Flows from "./flows";
import CustomModal from "../../UtilityComponents/customModal";
import UploadFlow from "./uploadFlow";
import EmptyScreen from "../../Assets/Empty-Screen.png";
import loader from "../../Assets/loaderTransaparent.gif";
import "./index.css";

function Processes(props){  

    const [modal, setModal] = useState(false);
    const [sampleBots,setSampleBots] = useState([])
    const [bots, setBots] = useState([]);
    const [botsList, setBotsList] = useState([]);
    const [loading, setLoading] = useState(false);
    const [count ,setCount] = useState()
    let [offSet,setOffset] = useState('0')
    let [limit,setLimit] = useState('6')

    const toggle = () => setModal(!modal);

    useEffect(() => {
      document.title = "Action Flows | E-Manager Console | Techforce.ai";
      const fetchData = async () => {
        setLoading(true);
        let payload={
          offSet,limit
        }
        let [data,sampleBots,botList] = await Promise.all([getProcesses(payload) ,getSampleBotList(), getProcesses()])
        setLoading(false);
        setSampleBots(sampleBots.sampleBots)
        if(data && data.rows.length > 0){
          setCount(data.count)
          setBots(data.rows)
          setBotsList(botList.rows)
        }
      };
      fetchData();
    }, []);

    const reloadProcess = React.useMemo(() => {
      return async event => {
        let payload={
          offSet,limit
        }
        let data = await getProcesses(payload);
        setBots(data.rows)  
        setCount(data.count)
      };
    },[bots]);
 
    const handleUploadSuccess = async () => {
      toggle();
      setLoading(true);
      let payload={
        offSet,limit
      }
      let data = await getProcesses(payload);      
      if(data && data.rows)
      {
        setCount(data.count);
        setBots(data.rows)
      }
      else
      { 
        setCount(0);
        setBots([]) 
 
      }        
      await reloadProcess()
      setLoading(false);
      
    }
    
    if(loading){
      return (
        <div className="main-content">
          <div className="header-content">
            <label>Action Flows</label>
          </div>
          <div style={{ textAlign: "center", marginTop: "15%" }}>
            <img src={loader} width="100" alt="loading"></img>
          </div>
        </div>
      );
    }
    else{      
      return (
        <div>
          {bots.length > 0 ? (
            <Flows toggle={() => toggle()} bots={bots} sampleBots={sampleBots} botsList={botsList}reloadProcess={reloadProcess} {...props} count={count} />
          ) : (
            <div className="main-content">
                <div className="header-content">
                <label>Action Flows</label>
              </div>
              <div className="empty-container text-center">
                <img src={EmptyScreen} alt="empty Screen"></img>
                <p>You don’t have any Action Flows yet</p>
                <small>Please publish an Action Flow</small>
                <div style={{ marginTop: "10px" }}>
                  <button className="btn" onClick={toggle}>
                    Publish
                  </button>
                </div>
              </div>
            </div>
          )}
          <div>
            {modal ? (
              <CustomModal
                comp={
                  <UploadFlow
                    uploadSuccess={() => handleUploadSuccess()}
                    toggle={() => toggle()}
                    sampleBots = {sampleBots}
                  />
                }
                name="Upload Action Flow"
                toggle={() => toggle()}
                modal={modal}
              />
            ) : null}
          </div>
        </div>
      );
      
    }
}

export default Processes;